// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__X5H2l","buttons":"PendingPaymentAlert_buttons__1Yl61"};